"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var findFieldByField = function findFieldByField(fields, fieldValue) {
  return fields.find(function (_ref) {
    var field = _ref.field;
    return field === fieldValue;
  });
};
var OrgDataEditor = /*#__PURE__*/function () {
  OrgDataEditor.$inject = ["$rootScope", "EventEmitter", "userService", "orgService"];
  /* @ngInject */
  function OrgDataEditor($rootScope, EventEmitter, userService, orgService) {
    _classCallCheck(this, OrgDataEditor);
    this.EventEmitter = EventEmitter;
    this.orgService = orgService;
    this.userService = userService;
    this.$rootScope = $rootScope;
  }
  _createClass(OrgDataEditor, [{
    key: "$onInit",
    value: function $onInit() {
      this.userIsSuperAdmin = this.userService.matchesRoles({
        globalRole: 'superadmin'
      });
      this.userIsSupport = this.userService.matchesRoles({
        globalRole: 'spotme_support'
      });
      this.isOrgAdmin = this.userService.matchesRoles({
        orgRole: 'admin',
        orgId: this.organisation._id
      });
      this.shouldShowEditProfileControls = this.userIsSuperAdmin || this.userIsSupport || this.isOrgAdmin;
      this.fields = angular.copy(this.$rootScope.defaultMetadataFields.org);
      (findFieldByField(this.fields, 'sf_account_id') || {}).kind = this.shouldShowEditProfileControls ? 'text' : 'static-text';
      var idField = findFieldByField(this.fields, 'name') || {};
      idField.kind = 'static-text';
      idField.label = 'Organization ID';
      var nameField = {
        field: 'display_name',
        kind: 'static-text',
        label: 'Organization name',
        validations: {
          required: true
        }
      };
      this.fields.unshift(nameField);
      this.superAdminFields = this.$rootScope.defaultMetadataFields.orgSuperadminControls;
      this.spotmeSupportFields = this.$rootScope.defaultMetadataFields.orgSupportControls;
      this.model = angular.copy(this.organisation);
      var industryField = this.spotmeSupportFields.find(function (f) {
        return f.field === 'org_industry';
      });
      this.model.org_industry = this.model.org_industry || industryField.default;
    }
  }, {
    key: "getDisplayedFieldValue",
    value: function getDisplayedFieldValue(val, kind) {
      if (kind === 'boolean') {
        return val ? 'yes' : 'no';
      }
      return val;
    }
  }, {
    key: "save",
    value: function save() {
      this.onSave(this.EventEmitter(this.model));
    }
  }]);
  return OrgDataEditor;
}();
module.exports = angular.module('backstage.components.orgs.view-org.editor', ['backstage.services']).component('bsOrgDataEditor', {
  templateUrl: '/src/angular/components/orgs/view-org/org-data-editor/org-data-editor.html',
  bindings: {
    organisation: '<',
    onSave: '&'
  },
  controller: OrgDataEditor
}).name;